import { c as _c } from "react/compiler-runtime";
import { InlineAlert } from '@systemeio/components';
import { InfoCircleIcon } from '@systemeio/icons';
import type { ReactNode } from 'react';
interface SectionMessageProps {
  children?: ReactNode;
  variant?: InlineAlert.Root.Variant;
  className?: string;
  iconClassName?: string;
  title?: ReactNode;
}
function SectionMessage(t0) {
  const $ = _c(15);
  const {
    children,
    variant,
    className,
    iconClassName,
    title
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <InfoCircleIcon aria-hidden={true} />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== iconClassName) {
    t2 = <InlineAlert.Icon className={iconClassName}>{t1}</InlineAlert.Icon>;
    $[1] = iconClassName;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== title) {
    t3 = title && <InlineAlert.Title>{title}</InlineAlert.Title>;
    $[3] = title;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== children) {
    t4 = children && <InlineAlert.Description>{children}</InlineAlert.Description>;
    $[5] = children;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3 || $[8] !== t4) {
    t5 = <InlineAlert.Content>{t3}{t4}</InlineAlert.Content>;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== className || $[11] !== t2 || $[12] !== t5 || $[13] !== variant) {
    t6 = <InlineAlert variant={variant} className={className}>{t2}{t5}</InlineAlert>;
    $[10] = className;
    $[11] = t2;
    $[12] = t5;
    $[13] = variant;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
}
export { SectionMessage };
export type { SectionMessageProps };